export const handleChangeDataBottomSheetEditPersonalInfo = (name, value) => ({
    type: 'CHANGE_DATA_BOTTOM_SHEET_EDIT_PERSONAL_INFO', name, value
});